import React from "react";

import Hidden from "@material-ui/core/Hidden";
import { useLocation, useRouteMatch } from "react-router-dom";

import MainHeader from "./MainHeader";
import MainMenu from "./MainMenu";
import MainRoutes from "./MainRoutes";
import useMainScreenStyles from "./useMainScreenStyles";

function MainScreen() {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const classes = useMainScreenStyles();

  const [menuOpen, setMenuOpen] = React.useState(false);

  const shouldRenderHeader = path === pathname;

  const handleOpenMenu = React.useCallback(() => {
    setMenuOpen(true);
  }, []);

  const handleCloseMenu = React.useCallback(() => {
    setMenuOpen(false);
  }, []);

  return (
    <>
      <Hidden only={["lg", "xl"]}>
        {shouldRenderHeader ? (
          <div
            className={`${classes.root} ${
              menuOpen ? classes.rootMenuOpen : ""
            }`}
          >
            <div className={classes.header}>
              <MainHeader onOpenMenu={handleOpenMenu} />
            </div>
            <div
              className={`${classes.menu} ${menuOpen ? classes.menuOpen : ""}`}
            >
              <MainMenu onCloseMenu={handleCloseMenu} />
            </div>
            <div
              className={`${classes.menuOverlay} ${
                menuOpen ? classes.menuOverlayOpen : ""
              }`}
            >
              <button
                type="button"
                onClick={handleCloseMenu}
                aria-label="Close menu"
              />
            </div>
            <div className={classes.content}>
              <MainRoutes />
            </div>
          </div>
        ) : (
          <div className={classes.root}>
            <div className={`${classes.content} ${classes.contentHeaderless}`}>
              <MainRoutes />
            </div>
          </div>
        )}
      </Hidden>
      <Hidden only={["xs", "sm", "md"]}>
        <div className={`${classes.root} ${classes.rootLarge}`}>
          <div className={`${classes.header} ${classes.headerLarge}`}>
            <MainHeader onOpenMenu={handleOpenMenu} />
          </div>
          <div className={classes.menuLarge}>
            <MainMenu />
          </div>
          <div className={`${classes.content} ${classes.contentLarge}`}>
            <MainRoutes />
          </div>
        </div>
      </Hidden>
    </>
  );
}

export default React.memo(MainScreen);
